<template>
    <div class="match-footer">
        <SdsIcon
            iconName="status-info"
            size="sm"
            class="match-footer__icon"
        />
        <span class="match-footer__text">{{ content }}</span>
    </div>
</template>

<script>
    import { SdsIcon } from '@superbet-group/web.lib.ui-components';
    export default {
        name: 'MatchFooterRow',
        props: {
            content: {
                type: String,
                required: true,
            },
        },
        components: {
            SdsIcon,
        },
    };
</script>

<style lang="scss" scoped>
    @import '~@superbet-group/web.lib.global-styles/type';
    @import '~@styles/layout/variables/offer__variables.icss';

    .match-footer {
        display: flex;
        align-items: center;
        gap: 12px;
        height: $event-row__footer-content__height;
        padding: 0 var(--space-padding-md);
        border-bottom-right-radius: var(--radius-sm);
        border-bottom-left-radius: var(--radius-sm);
        background-color: var(--system-bg-elevation-layer-1);
        // box-shadow: var(--shadows-system-default);
        @include font-12-regular;
        line-height: 1.3333;
        color: var(--system-text-on-elevation-secondary);

        &::v-deep &__icon {
            color: var(--system-graphics-on-elevation-secondary);
        }

        &__text {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

</style>
